module.exports = __webpack_public_path__ + "img/logo_assobens.6ce1f125.jpg";